module.exports = __webpack_public_path__ + "static/media/SickLeave.b8ba343a.svg";